import { makeStyles } from '@material-ui/core/styles';

export const useAlertMessageStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '24px',
    padding: (props) => (props.mobile ? '24px' : null),
    backgroundColor: (props) => (props.mobile ? '#F1F1F1' : null),
  },
}));
